import gql from 'graphql-tag'

export const GENERATE_DOWNLOAD_LINK = gql`
  mutation GenerateDownloadLinkMutation($id: ID!) {
    gerarLinkDownloadByItemBiblioteca(idItemBiblioteca: $id)
  }
`
